<template>
  <div>
    <v-badge
      class="dashboard__badge"
      :offset-x="quantidadePorServico > limit / 10 ? 40 : 25"
      offset-y="20"
      color="white"
    >
      <template #badge>
        <span :style="{ color: getColor() }">{{
          quantidadePorServico > limit ? limit + '+' : quantidadePorServico
        }}</span>
      </template>
      <v-sheet
        class="dashboard__sheet black--text d-flex justify-center"
        rounded="xl"
        outlined
        :class="{ 'align-center': !servico.etapas.length }"
        :style="{ border: `3px solid ${getColor()}` }"
      >
        <div class="d-flex flex-column flex-grow-1 pa-4">
          <h3
            v-if="!servico.etapas.length"
            class="text-center"
            :style="{ color: getColor(), cursor: 'pointer' }"
            v-on:click="setServico(servico)"
          >
            {{ nomeServico | upper }}
          </h3>
          <p
            v-else
            class="text-center"
            :style="{ color: getColor(), cursor: 'pointer' }"
            v-on:click="setServico(servico)"
          >
            {{ nomeServico | upper }}
          </p>
          <div
            v-for="(etapa, index) in etapaComContadores"
            :key="index"
            class="d-flex align-center py-2 px-4"
            :style="{ cursor: 'pointer' }"
            v-on:click="setEtapa(etapa)"
          >
            <p class="mb-0 flex-grow-1">{{ etapa.descricao }}</p>
            <v-chip small color="primary">
              {{
                etapa.quantidadePorEtapa > limit
                  ? limit + '+'
                  : etapa.quantidadePorEtapa
              }}
            </v-chip>
          </div>
        </div>
      </v-sheet>
    </v-badge>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// import PatioApi from '@/services/patio'
import { mapMutations, mapState } from 'vuex'

export default {
  props: {
    index: Number,
    limit: Number,
    descricao: String,
    gate: String,
    servico: {
      type: Object,
      default: () => ({etapas: []}),
    },
  },
  filters: {
    upper(value) {
      return value.toUpperCase()
    },
  },

  data() {
    return {
      nomeServico: '',
      etapaComContadores: [],
      quantidadePorServico: 0,
      colors: {
        0: 'red',
        1: 'green',
        2: 'blue',
        3: 'orange',
        4: 'purple',
        5: 'brown',
        6: 'pink',
        7: 'grey',
        8: 'indigo',
        9: 'teal',
      },
      defaultColor: 'black',
      allowedStatus: ['AGENDADOS'],
    }
  },

  computed: {
    ...mapState('gerenciamentoServico', ['params']),
    ...mapState('auth', ['empresaAtual']),
    ehStatus() {
      return this.allowedStatus.includes(this.descricao)
    },
  },

  methods: {
    ...mapActions('patio', ['getDashboardCountByParams']),
    ...mapMutations('gerenciamentoServico', ['UPDATE_PARAMS']),

    setServico(servico) {
      let params = this.params
      if(this.ehStatus) {
        params['servico'] = servico.ids[0]
      } else {
        params['servico'] = servico.ids
      }
      params['proprietario'] = this.empresaAtual.public_id
      if (this.gate) {
        params['gate'] = this.gate
      }
      delete params.etapa
      this.UPDATE_PARAMS(params)
      this.$emit('search')
    },
    setEtapa(etapa) {
      let params = this.params

      params['servico'] = etapa.servico.ids
      params['etapa'] = etapa.public_ids
      params['proprietario'] = this.empresaAtual.public_id
      if (this.gate) {
        params['gate'] = this.gate
      }

      this.UPDATE_PARAMS(params)
      this.$emit('search')
    },

    getColor() {
      return this.colors[this.index] || this.defaultColor
    },

    async populateEtapa(etapa) {
      let params = { ...this.params }
      params['proprietario'] = this.empresaAtual.public_id
      if (this.gate) {
        params['gate'] = this.gate
      }
      if (params.servico) {
        delete params.servico
      }
      if (params.etapa) {
        delete params.etapa
      }
      const quantidadePorEtapa = await this.getDashboardCountByParams({
        ...params,
        servico: etapa.servico.ids,
        etapa: etapa.public_ids,
      })

      return {
        ...etapa,
        quantidadePorEtapa,
      }
    },

    async getContadorServico() {
      let params = { ...this.params }
      params['proprietario'] = this.empresaAtual.public_id
      if (this.gate) {
        params['gate'] = this.gate
      }
      if (params.servico) {
        delete params.servico
      }
      if (this.ehStatus) {
        this.quantidadePorServico = await this.getDashboardCountByParams({
          ...params,
          status: this.servico.ids[0],
        })
      } else {
        this.quantidadePorServico = await this.getDashboardCountByParams({
          ...params,
          servico: this.servico.ids,
        })
      }
    },

    async getContadoresEtapas() {
      let etapaComContadores = []
      this.servico.etapas.forEach(async (etapa) => {
        const etapaComContador = await this.populateEtapa(etapa)
        etapaComContadores.push(etapaComContador)
      })
      this.etapaComContadores = etapaComContadores
    },

    async getContadores() {
      await this.getContadorServico()
      await this.getContadoresEtapas()
    },

    async getServicoLabel() {
      if (this.descricao === 'AGENDADO') {
        this.nomeServico = 'Agendados'
      } else {
        this.nomeServico = this.descricao
      }
    },
  },

  async created() {
    await this.getServicoLabel()
  },
}
</script>

<style>
.dashboard__badge,
.dashboard__sheet {
  height: 100%;
  width: 100%;
}

.dashboard__badge .v-badge__badge {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  text-align: center;
  border-radius: 50%;
  height: 30px;
}
</style>
